export const LIMITS = {
  REWARDS_HISTORY: 10,
};
